var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    className: "header__nav-link-icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_902_9778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.544 4.175a.583.583 0 0 0 0 .817l.933.933a.583.583 0 0 0 .817 0l2.2-2.2a3.5 3.5 0 0 1-4.632 4.633l-4.031 4.03a1.237 1.237 0 1 1-1.75-1.75l4.03-4.03a3.5 3.5 0 0 1 4.632-4.632L9.55 4.169l-.006.006Z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_902_9778"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.969.5h14v14h-14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/Tools.8e0f14b6efc028c323cccb63034077f3.svg";
export { ForwardRef as ReactComponent };